"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FrontEndError = void 0;
exports.getFrontEndErrorFromAxiosError = getFrontEndErrorFromAxiosError;
exports.getLogErrorLevel = getLogErrorLevel;
exports.logError = logError;
exports.logWidgetInfo = logWidgetInfo;
exports.logWidgetUsageInfo = logWidgetUsageInfo;
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
require("core-js/modules/es6.string.ends-with.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _axios = _interopRequireDefault(require("axios"));
function cov_1os3lnb8am() {
  var path = "/codebuild/output/src2967687754/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/GAxios/lib/index.js";
  var hash = "c60d89eda715875eb3a2e96f6223c7654cd30949";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2967687754/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/GAxios/lib/index.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 27
        },
        end: {
          line: 4,
          column: 35
        }
      },
      "1": {
        start: {
          line: 6,
          column: 20
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 29
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "3": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "4": {
        start: {
          line: 43,
          column: 17
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "5": {
        start: {
          line: 49,
          column: 27
        },
        end: {
          line: 49,
          column: 62
        }
      },
      "6": {
        start: {
          line: 49,
          column: 34
        },
        end: {
          line: 49,
          column: 62
        }
      },
      "7": {
        start: {
          line: 51,
          column: 22
        },
        end: {
          line: 52,
          column: 80
        }
      },
      "8": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 52,
          column: 80
        }
      },
      "9": {
        start: {
          line: 54,
          column: 21
        },
        end: {
          line: 54,
          column: 88
        }
      },
      "10": {
        start: {
          line: 54,
          column: 44
        },
        end: {
          line: 54,
          column: 88
        }
      },
      "11": {
        start: {
          line: 56,
          column: 23
        },
        end: {
          line: 56,
          column: 70
        }
      },
      "12": {
        start: {
          line: 56,
          column: 34
        },
        end: {
          line: 56,
          column: 70
        }
      },
      "13": {
        start: {
          line: 58,
          column: 26
        },
        end: {
          line: 58,
          column: 61
        }
      },
      "14": {
        start: {
          line: 58,
          column: 32
        },
        end: {
          line: 58,
          column: 61
        }
      },
      "15": {
        start: {
          line: 60,
          column: 26
        },
        end: {
          line: 60,
          column: 67
        }
      },
      "16": {
        start: {
          line: 60,
          column: 38
        },
        end: {
          line: 60,
          column: 67
        }
      },
      "17": {
        start: {
          line: 62,
          column: 25
        },
        end: {
          line: 62,
          column: 76
        }
      },
      "18": {
        start: {
          line: 62,
          column: 37
        },
        end: {
          line: 62,
          column: 76
        }
      },
      "19": {
        start: {
          line: 64,
          column: 25
        },
        end: {
          line: 68,
          column: 1
        }
      },
      "20": {
        start: {
          line: 65,
          column: 18
        },
        end: {
          line: 65,
          column: 60
        }
      },
      "21": {
        start: {
          line: 66,
          column: 24
        },
        end: {
          line: 66,
          column: 70
        }
      },
      "22": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 67,
          column: 64
        }
      },
      "23": {
        start: {
          line: 70,
          column: 28
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "24": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 73,
          column: 3
        }
      },
      "25": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 16
        }
      },
      "26": {
        start: {
          line: 74,
          column: 32
        },
        end: {
          line: 74,
          column: 42
        }
      },
      "27": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 75,
          column: 70
        }
      },
      "28": {
        start: {
          line: 78,
          column: 14
        },
        end: {
          line: 78,
          column: 60
        }
      },
      "29": {
        start: {
          line: 78,
          column: 23
        },
        end: {
          line: 78,
          column: 60
        }
      },
      "30": {
        start: {
          line: 81,
          column: 2
        },
        end: {
          line: 101,
          column: 3
        }
      },
      "31": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      "32": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 23
        }
      },
      "33": {
        start: {
          line: 85,
          column: 23
        },
        end: {
          line: 85,
          column: 33
        }
      },
      "34": {
        start: {
          line: 86,
          column: 47
        },
        end: {
          line: 86,
          column: 59
        }
      },
      "35": {
        start: {
          line: 88,
          column: 16
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "36": {
        start: {
          line: 93,
          column: 19
        },
        end: {
          line: 93,
          column: 50
        }
      },
      "37": {
        start: {
          line: 94,
          column: 23
        },
        end: {
          line: 94,
          column: 64
        }
      },
      "38": {
        start: {
          line: 96,
          column: 23
        },
        end: {
          line: 96,
          column: 81
        }
      },
      "39": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 57
        }
      },
      "40": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 21
        }
      },
      "41": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 107,
          column: 3
        }
      },
      "42": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 21
        }
      },
      "43": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 99
        }
      },
      "44": {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 114,
          column: 3
        }
      },
      "45": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 25
        }
      },
      "46": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 115,
          column: 24
        }
      },
      "47": {
        start: {
          line: 120,
          column: 2
        },
        end: {
          line: 155,
          column: 3
        }
      },
      "48": {
        start: {
          line: 121,
          column: 42
        },
        end: {
          line: 121,
          column: 58
        }
      },
      "49": {
        start: {
          line: 122,
          column: 24
        },
        end: {
          line: 122,
          column: 57
        }
      },
      "50": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 125,
          column: 5
        }
      },
      "51": {
        start: {
          line: 124,
          column: 6
        },
        end: {
          line: 124,
          column: 18
        }
      },
      "52": {
        start: {
          line: 127,
          column: 26
        },
        end: {
          line: 127,
          column: 57
        }
      },
      "53": {
        start: {
          line: 128,
          column: 20
        },
        end: {
          line: 128,
          column: 46
        }
      },
      "54": {
        start: {
          line: 129,
          column: 28
        },
        end: {
          line: 129,
          column: 72
        }
      },
      "55": {
        start: {
          line: 130,
          column: 22
        },
        end: {
          line: 133,
          column: 5
        }
      },
      "56": {
        start: {
          line: 134,
          column: 26
        },
        end: {
          line: 134,
          column: 45
        }
      },
      "57": {
        start: {
          line: 135,
          column: 21
        },
        end: {
          line: 135,
          column: 44
        }
      },
      "58": {
        start: {
          line: 136,
          column: 20
        },
        end: {
          line: 136,
          column: 58
        }
      },
      "59": {
        start: {
          line: 138,
          column: 23
        },
        end: {
          line: 146,
          column: 4
        }
      },
      "60": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 152,
          column: 7
        }
      },
      "61": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 16
        }
      },
      "62": {
        start: {
          line: 160,
          column: 2
        },
        end: {
          line: 178,
          column: 3
        }
      },
      "63": {
        start: {
          line: 161,
          column: 24
        },
        end: {
          line: 161,
          column: 57
        }
      },
      "64": {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 164,
          column: 5
        }
      },
      "65": {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 163,
          column: 18
        }
      },
      "66": {
        start: {
          line: 166,
          column: 26
        },
        end: {
          line: 166,
          column: 45
        }
      },
      "67": {
        start: {
          line: 167,
          column: 26
        },
        end: {
          line: 167,
          column: 57
        }
      },
      "68": {
        start: {
          line: 168,
          column: 20
        },
        end: {
          line: 168,
          column: 58
        }
      },
      "69": {
        start: {
          line: 169,
          column: 23
        },
        end: {
          line: 169,
          column: 88
        }
      },
      "70": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 175,
          column: 7
        }
      },
      "71": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 16
        }
      },
      "72": {
        start: {
          line: 182,
          column: 2
        },
        end: {
          line: 200,
          column: 3
        }
      },
      "73": {
        start: {
          line: 183,
          column: 24
        },
        end: {
          line: 183,
          column: 57
        }
      },
      "74": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 186,
          column: 5
        }
      },
      "75": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 185,
          column: 18
        }
      },
      "76": {
        start: {
          line: 188,
          column: 26
        },
        end: {
          line: 188,
          column: 45
        }
      },
      "77": {
        start: {
          line: 189,
          column: 26
        },
        end: {
          line: 189,
          column: 57
        }
      },
      "78": {
        start: {
          line: 190,
          column: 20
        },
        end: {
          line: 190,
          column: 58
        }
      },
      "79": {
        start: {
          line: 191,
          column: 23
        },
        end: {
          line: 191,
          column: 93
        }
      },
      "80": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 197,
          column: 7
        }
      },
      "81": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 199,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 27
          },
          end: {
            line: 49,
            column: 28
          }
        },
        loc: {
          start: {
            line: 49,
            column: 34
          },
          end: {
            line: 49,
            column: 62
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 51,
            column: 23
          }
        },
        loc: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 80
          }
        },
        line: 52
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 22
          }
        },
        loc: {
          start: {
            line: 54,
            column: 44
          },
          end: {
            line: 54,
            column: 88
          }
        },
        line: 54
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 56,
            column: 23
          },
          end: {
            line: 56,
            column: 24
          }
        },
        loc: {
          start: {
            line: 56,
            column: 34
          },
          end: {
            line: 56,
            column: 70
          }
        },
        line: 56
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 58,
            column: 26
          },
          end: {
            line: 58,
            column: 27
          }
        },
        loc: {
          start: {
            line: 58,
            column: 32
          },
          end: {
            line: 58,
            column: 61
          }
        },
        line: 58
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 60,
            column: 26
          },
          end: {
            line: 60,
            column: 27
          }
        },
        loc: {
          start: {
            line: 60,
            column: 38
          },
          end: {
            line: 60,
            column: 67
          }
        },
        line: 60
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 62,
            column: 25
          },
          end: {
            line: 62,
            column: 26
          }
        },
        loc: {
          start: {
            line: 62,
            column: 37
          },
          end: {
            line: 62,
            column: 76
          }
        },
        line: 62
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 64,
            column: 25
          },
          end: {
            line: 64,
            column: 26
          }
        },
        loc: {
          start: {
            line: 64,
            column: 49
          },
          end: {
            line: 68,
            column: 1
          }
        },
        line: 64
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 70,
            column: 28
          },
          end: {
            line: 70,
            column: 29
          }
        },
        loc: {
          start: {
            line: 70,
            column: 42
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 70
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 78,
            column: 14
          },
          end: {
            line: 78,
            column: 15
          }
        },
        loc: {
          start: {
            line: 78,
            column: 23
          },
          end: {
            line: 78,
            column: 60
          }
        },
        line: 78
      },
      "10": {
        name: "getRequestInfo",
        decl: {
          start: {
            line: 80,
            column: 9
          },
          end: {
            line: 80,
            column: 23
          }
        },
        loc: {
          start: {
            line: 80,
            column: 36
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 80
      },
      "11": {
        name: "getFrontEndErrorFromAxiosError",
        decl: {
          start: {
            line: 104,
            column: 16
          },
          end: {
            line: 104,
            column: 46
          }
        },
        loc: {
          start: {
            line: 104,
            column: 59
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 104
      },
      "12": {
        name: "getLogErrorLevel",
        decl: {
          start: {
            line: 111,
            column: 16
          },
          end: {
            line: 111,
            column: 32
          }
        },
        loc: {
          start: {
            line: 111,
            column: 40
          },
          end: {
            line: 116,
            column: 1
          }
        },
        line: 111
      },
      "13": {
        name: "logError",
        decl: {
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 30
          }
        },
        loc: {
          start: {
            line: 119,
            column: 87
          },
          end: {
            line: 156,
            column: 1
          }
        },
        line: 119
      },
      "14": {
        name: "logWidgetInfo",
        decl: {
          start: {
            line: 159,
            column: 22
          },
          end: {
            line: 159,
            column: 35
          }
        },
        loc: {
          start: {
            line: 159,
            column: 72
          },
          end: {
            line: 179,
            column: 1
          }
        },
        line: 159
      },
      "15": {
        name: "logWidgetUsageInfo",
        decl: {
          start: {
            line: 181,
            column: 22
          },
          end: {
            line: 181,
            column: 40
          }
        },
        loc: {
          start: {
            line: 181,
            column: 82
          },
          end: {
            line: 201,
            column: 1
          }
        },
        line: 181
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 49,
            column: 34
          },
          end: {
            line: 49,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 34
          },
          end: {
            line: 49,
            column: 37
          }
        }, {
          start: {
            line: 49,
            column: 41
          },
          end: {
            line: 49,
            column: 62
          }
        }],
        line: 49
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 75
          }
        }, {
          start: {
            line: 52,
            column: 78
          },
          end: {
            line: 52,
            column: 80
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 52,
            column: 42
          }
        }, {
          start: {
            line: 52,
            column: 46
          },
          end: {
            line: 52,
            column: 75
          }
        }],
        line: 52
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 34
          },
          end: {
            line: 56,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 34
          },
          end: {
            line: 56,
            column: 41
          }
        }, {
          start: {
            line: 56,
            column: 45
          },
          end: {
            line: 56,
            column: 70
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 67,
            column: 9
          },
          end: {
            line: 67,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 9
          },
          end: {
            line: 67,
            column: 27
          }
        }, {
          start: {
            line: 67,
            column: 31
          },
          end: {
            line: 67,
            column: 63
          }
        }],
        line: 67
      },
      "5": {
        loc: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 71
      },
      "6": {
        loc: {
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 75,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 18
          }
        }, {
          start: {
            line: 75,
            column: 22
          },
          end: {
            line: 75,
            column: 37
          }
        }, {
          start: {
            line: 75,
            column: 43
          },
          end: {
            line: 75,
            column: 50
          }
        }, {
          start: {
            line: 75,
            column: 54
          },
          end: {
            line: 75,
            column: 68
          }
        }],
        line: 75
      },
      "7": {
        loc: {
          start: {
            line: 78,
            column: 23
          },
          end: {
            line: 78,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 23
          },
          end: {
            line: 78,
            column: 42
          }
        }, {
          start: {
            line: 78,
            column: 46
          },
          end: {
            line: 78,
            column: 60
          }
        }],
        line: 78
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "9": {
        loc: {
          start: {
            line: 86,
            column: 47
          },
          end: {
            line: 86,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 47
          },
          end: {
            line: 86,
            column: 53
          }
        }, {
          start: {
            line: 86,
            column: 57
          },
          end: {
            line: 86,
            column: 59
          }
        }],
        line: 86
      },
      "10": {
        loc: {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 14
          }
        }, {
          start: {
            line: 89,
            column: 18
          },
          end: {
            line: 89,
            column: 20
          }
        }],
        line: 89
      },
      "11": {
        loc: {
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 90,
            column: 42
          },
          end: {
            line: 90,
            column: 55
          }
        }, {
          start: {
            line: 90,
            column: 58
          },
          end: {
            line: 90,
            column: 65
          }
        }],
        line: 90
      },
      "12": {
        loc: {
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 13
          }
        }, {
          start: {
            line: 90,
            column: 17
          },
          end: {
            line: 90,
            column: 39
          }
        }],
        line: 90
      },
      "13": {
        loc: {
          start: {
            line: 94,
            column: 23
          },
          end: {
            line: 94,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 39
          },
          end: {
            line: 94,
            column: 55
          }
        }, {
          start: {
            line: 94,
            column: 58
          },
          end: {
            line: 94,
            column: 64
          }
        }],
        line: 94
      },
      "14": {
        loc: {
          start: {
            line: 96,
            column: 23
          },
          end: {
            line: 96,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 24
          },
          end: {
            line: 96,
            column: 30
          }
        }, {
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 60
          }
        }, {
          start: {
            line: 96,
            column: 65
          },
          end: {
            line: 96,
            column: 81
          }
        }],
        line: 96
      },
      "15": {
        loc: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 105
      },
      "16": {
        loc: {
          start: {
            line: 108,
            column: 9
          },
          end: {
            line: 108,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 108,
            column: 43
          },
          end: {
            line: 108,
            column: 69
          }
        }, {
          start: {
            line: 108,
            column: 72
          },
          end: {
            line: 108,
            column: 98
          }
        }],
        line: 108
      },
      "17": {
        loc: {
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 112
      },
      "18": {
        loc: {
          start: {
            line: 121,
            column: 42
          },
          end: {
            line: 121,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 42
          },
          end: {
            line: 121,
            column: 52
          }
        }, {
          start: {
            line: 121,
            column: 56
          },
          end: {
            line: 121,
            column: 58
          }
        }],
        line: 121
      },
      "19": {
        loc: {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 125,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 123
      },
      "20": {
        loc: {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 131,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 24
          },
          end: {
            line: 131,
            column: 29
          }
        }, {
          start: {
            line: 131,
            column: 32
          },
          end: {
            line: 131,
            column: 61
          }
        }],
        line: 131
      },
      "21": {
        loc: {
          start: {
            line: 136,
            column: 20
          },
          end: {
            line: 136,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 20
          },
          end: {
            line: 136,
            column: 45
          }
        }, {
          start: {
            line: 136,
            column: 49
          },
          end: {
            line: 136,
            column: 58
          }
        }],
        line: 136
      },
      "22": {
        loc: {
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 162,
            column: 4
          },
          end: {
            line: 164,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 162
      },
      "23": {
        loc: {
          start: {
            line: 168,
            column: 20
          },
          end: {
            line: 168,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 20
          },
          end: {
            line: 168,
            column: 45
          }
        }, {
          start: {
            line: 168,
            column: 49
          },
          end: {
            line: 168,
            column: 58
          }
        }],
        line: 168
      },
      "24": {
        loc: {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 186,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 184
      },
      "25": {
        loc: {
          start: {
            line: 190,
            column: 20
          },
          end: {
            line: 190,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 190,
            column: 20
          },
          end: {
            line: 190,
            column: 45
          }
        }, {
          start: {
            line: 190,
            column: 49
          },
          end: {
            line: 190,
            column: 58
          }
        }],
        line: 190
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c60d89eda715875eb3a2e96f6223c7654cd30949"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1os3lnb8am = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1os3lnb8am();
// TODO: Temporary. To be replaced in the other ticket
var TEMP_LOG_STX_AUTHN = (cov_1os3lnb8am().s[0]++, '123456');
var LogEndPoint = (cov_1os3lnb8am().s[1]++, {
  ERROR: 'error',
  WIDGET_INFO: 'widgetInfo'
});
var FrontEndError = exports.FrontEndError = (cov_1os3lnb8am().s[2]++, {
  LoadWidGetError: '100',
  RenderWidgetError: '200',
  RestActionError: '300',
  APICallError: '400',
  NetWorkError: '401',
  UnexpectedError: '500'
});
var SupportedWidget = (cov_1os3lnb8am().s[3]++, {
  UnknownWidget: 'UNK',
  Footer: 'FOOT',
  WidgetDoc: 'DOC',
  Payment: 'PAY',
  AliasCreation: 'ALCR',
  Header: 'HEAD',
  Newsletter: 'NEWSL',
  SeatMap: 'SMAP',
  Product: 'PROD',
  AvailabilityCalendar: 'ACAL',
  DailySchedule: 'DSCHE',
  Section: 'SEC',
  Catalog: 'CAT',
  SeasonCalendar: 'SSCAL',
  OneClickPurchase: 'OCPURC',
  ProducerDashboard: 'PDASH',
  ProductList: 'PLIST',
  TicketShop: 'TS',
  TournamentCatalog: 'TCAT',
  CsrfToken: 'CSRF'
});
var LogLevel = (cov_1os3lnb8am().s[4]++, {
  Error: 'ERROR',
  Info: 'INFO',
  Debug: 'DEBUG'
});
cov_1os3lnb8am().s[5]++;
var getHostNameFromURL = function getHostNameFromURL(url) {
  cov_1os3lnb8am().f[0]++;
  cov_1os3lnb8am().s[6]++;
  return (cov_1os3lnb8am().b[0][0]++, url) && (cov_1os3lnb8am().b[0][1]++, new URL(url).hostname);
};
cov_1os3lnb8am().s[7]++;
var getWidgetCode = function getWidgetCode(widgetName) {
  cov_1os3lnb8am().f[1]++;
  cov_1os3lnb8am().s[8]++;
  return widgetName ? (cov_1os3lnb8am().b[1][0]++, (cov_1os3lnb8am().b[2][0]++, SupportedWidget[widgetName]) || (cov_1os3lnb8am().b[2][1]++, SupportedWidget.UnknownWidget)) : (cov_1os3lnb8am().b[1][1]++, '');
};
cov_1os3lnb8am().s[9]++;
var getErrorCode = function getErrorCode(error, widgetName) {
  cov_1os3lnb8am().f[2]++;
  cov_1os3lnb8am().s[10]++;
  return "STXWI-".concat(error).concat(getWidgetCode(widgetName));
};
cov_1os3lnb8am().s[11]++;
var getStxHostName = function getStxHostName(headers) {
  cov_1os3lnb8am().f[3]++;
  cov_1os3lnb8am().s[12]++;
  return (cov_1os3lnb8am().b[3][0]++, headers) && (cov_1os3lnb8am().b[3][1]++, headers['X-Secutix-Host']);
};
cov_1os3lnb8am().s[13]++;
var getWindowLocation = function getWindowLocation() {
  cov_1os3lnb8am().f[4]++;
  cov_1os3lnb8am().s[14]++;
  return window.document.location.href;
};
cov_1os3lnb8am().s[15]++;
var getRestApiBaseURL = function getRestApiBaseURL(hostName) {
  cov_1os3lnb8am().f[5]++;
  cov_1os3lnb8am().s[16]++;
  return "https://".concat(hostName, "/tnwr/v1");
};
cov_1os3lnb8am().s[17]++;
var getLogApiBaseURL = function getLogApiBaseURL(hostName) {
  cov_1os3lnb8am().f[6]++;
  cov_1os3lnb8am().s[18]++;
  return "https://".concat(hostName, "/api/v1/monitoring");
};
cov_1os3lnb8am().s[19]++;
var getDebugClientId = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(headers) {
    var baseURL, axiosResponse;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cov_1os3lnb8am().f[7]++;
          baseURL = (cov_1os3lnb8am().s[20]++, getRestApiBaseURL(getStxHostName(headers)));
          cov_1os3lnb8am().s[21]++;
          _context.next = 5;
          return _axios.default.get('/csrf', {
            headers: headers,
            baseURL: baseURL
          });
        case 5:
          axiosResponse = _context.sent;
          cov_1os3lnb8am().s[22]++;
          return _context.abrupt("return", (cov_1os3lnb8am().b[4][0]++, axiosResponse.data) && (cov_1os3lnb8am().b[4][1]++, axiosResponse.data.debugClientId));
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getDebugClientId(_x) {
    return _ref.apply(this, arguments);
  };
}();
cov_1os3lnb8am().s[23]++;
var getAxiosErrorStatus = function getAxiosErrorStatus(axiosError) {
  cov_1os3lnb8am().f[8]++;
  cov_1os3lnb8am().s[24]++;
  if (!axiosError) {
    cov_1os3lnb8am().b[5][0]++;
    cov_1os3lnb8am().s[25]++;
    return null;
  } else {
    cov_1os3lnb8am().b[5][1]++;
  }
  var _ref2 = (cov_1os3lnb8am().s[26]++, axiosError),
    request = _ref2.request,
    response = _ref2.response;
  cov_1os3lnb8am().s[27]++;
  return (cov_1os3lnb8am().b[6][0]++, response) && (cov_1os3lnb8am().b[6][1]++, response.status) || (cov_1os3lnb8am().b[6][2]++, request) && (cov_1os3lnb8am().b[6][3]++, request.status);
};
cov_1os3lnb8am().s[28]++;
var isNil = function isNil(value) {
  cov_1os3lnb8am().f[9]++;
  cov_1os3lnb8am().s[29]++;
  return (cov_1os3lnb8am().b[7][0]++, value === undefined) || (cov_1os3lnb8am().b[7][1]++, value === null);
};
function getRequestInfo(axiosError) {
  cov_1os3lnb8am().f[10]++;
  cov_1os3lnb8am().s[30]++;
  try {
    cov_1os3lnb8am().s[31]++;
    if (!axiosError) {
      cov_1os3lnb8am().b[8][0]++;
      cov_1os3lnb8am().s[32]++;
      return undefined;
    } else {
      cov_1os3lnb8am().b[8][1]++;
    }
    var _ref3 = (cov_1os3lnb8am().s[33]++, axiosError),
      config = _ref3.config;
    var _ref4 = (cov_1os3lnb8am().s[34]++, (cov_1os3lnb8am().b[9][0]++, config) || (cov_1os3lnb8am().b[9][1]++, {})),
      method = _ref4.method,
      baseURL = _ref4.baseURL,
      endpoint = _ref4.url;
    var url = (cov_1os3lnb8am().s[35]++, new URL((cov_1os3lnb8am().b[10][0]++, endpoint) || (cov_1os3lnb8am().b[10][1]++, ''), (cov_1os3lnb8am().b[12][0]++, baseURL) && (cov_1os3lnb8am().b[12][1]++, !baseURL.endsWith('/')) ? (cov_1os3lnb8am().b[11][0]++, "".concat(baseURL, "/")) : (cov_1os3lnb8am().b[11][1]++, baseURL)));
    var status = (cov_1os3lnb8am().s[36]++, getAxiosErrorStatus(axiosError));
    var statusText = (cov_1os3lnb8am().s[37]++, isNil(status) ? (cov_1os3lnb8am().b[13][0]++, 'UNKNOWN STATUS') : (cov_1os3lnb8am().b[13][1]++, status));
    var methodText = (cov_1os3lnb8am().s[38]++, (cov_1os3lnb8am().b[14][0]++, method) && (cov_1os3lnb8am().b[14][1]++, method.toLocaleUpperCase()) || (cov_1os3lnb8am().b[14][2]++, 'UNKNOWN METHOD'));
    cov_1os3lnb8am().s[39]++;
    return "".concat(methodText, " ").concat(url.pathname, " ").concat(statusText);
  } catch (e) {
    cov_1os3lnb8am().s[40]++;
    return undefined;
  }
}
function getFrontEndErrorFromAxiosError(axiosError) {
  cov_1os3lnb8am().f[11]++;
  cov_1os3lnb8am().s[41]++;
  if (!axiosError) {
    cov_1os3lnb8am().b[15][0]++;
    cov_1os3lnb8am().s[42]++;
    return undefined;
  } else {
    cov_1os3lnb8am().b[15][1]++;
  }
  cov_1os3lnb8am().s[43]++;
  return getAxiosErrorStatus(axiosError) ? (cov_1os3lnb8am().b[16][0]++, FrontEndError.APICallError) : (cov_1os3lnb8am().b[16][1]++, FrontEndError.NetWorkError);
}
function getLogErrorLevel(error) {
  cov_1os3lnb8am().f[12]++;
  cov_1os3lnb8am().s[44]++;
  if (error === FrontEndError.NetWorkError) {
    cov_1os3lnb8am().b[17][0]++;
    cov_1os3lnb8am().s[45]++;
    return LogLevel.Info;
  } else {
    cov_1os3lnb8am().b[17][1]++;
  }
  cov_1os3lnb8am().s[46]++;
  return LogLevel.Error;
}

// Create a generic function to send an error
function logError(_x2, _x3, _x4, _x5, _x6) {
  return _logError.apply(this, arguments);
} // log widget usage
function _logError() {
  _logError = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(error, headers, widgetInfo, axiosError, additionalInfo) {
    var _ref5, widgetName, widgetBaseURL, logHostName, debugClientId, request, isExpectedError, errorCode, usagePlaceURL, logLevel, version, logPayload;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          cov_1os3lnb8am().f[13]++;
          cov_1os3lnb8am().s[47]++;
          _context2.prev = 2;
          _ref5 = (cov_1os3lnb8am().s[48]++, (cov_1os3lnb8am().b[18][0]++, widgetInfo) || (cov_1os3lnb8am().b[18][1]++, {})), widgetName = _ref5.widgetName, widgetBaseURL = _ref5.widgetBaseURL;
          logHostName = (cov_1os3lnb8am().s[49]++, getHostNameFromURL(widgetBaseURL));
          cov_1os3lnb8am().s[50]++;
          if (logHostName) {
            _context2.next = 12;
            break;
          }
          cov_1os3lnb8am().b[19][0]++;
          cov_1os3lnb8am().s[51]++;
          return _context2.abrupt("return", null);
        case 12:
          cov_1os3lnb8am().b[19][1]++;
        case 13:
          cov_1os3lnb8am().s[52]++;
          _context2.next = 16;
          return getDebugClientId(headers);
        case 16:
          debugClientId = _context2.sent;
          request = (cov_1os3lnb8am().s[53]++, getRequestInfo(axiosError));
          isExpectedError = (cov_1os3lnb8am().s[54]++, (0, _values.default)(FrontEndError).includes(error));
          errorCode = (cov_1os3lnb8am().s[55]++, getErrorCode(isExpectedError ? (cov_1os3lnb8am().b[20][0]++, error) : (cov_1os3lnb8am().b[20][1]++, FrontEndError.UnexpectedError), widgetName));
          usagePlaceURL = (cov_1os3lnb8am().s[56]++, getWindowLocation());
          logLevel = (cov_1os3lnb8am().s[57]++, getLogErrorLevel(error));
          version = (cov_1os3lnb8am().s[58]++, (cov_1os3lnb8am().b[21][0]++, process.env.BUILD_VERSION) || (cov_1os3lnb8am().b[21][1]++, 'UNKNOWN'));
          logPayload = (cov_1os3lnb8am().s[59]++, {
            errorCode: errorCode,
            usagePlaceURL: usagePlaceURL,
            debugClientId: debugClientId,
            request: request,
            logLevel: logLevel,
            version: version,
            additionalInfo: additionalInfo
          });
          cov_1os3lnb8am().s[60]++;
          return _context2.abrupt("return", _axios.default.post(LogEndPoint.ERROR, logPayload, {
            headers: {
              'X-Stx-Authn': TEMP_LOG_STX_AUTHN
            },
            baseURL: getLogApiBaseURL(logHostName)
          }));
        case 28:
          _context2.prev = 28;
          _context2.t0 = _context2["catch"](2);
          cov_1os3lnb8am().s[61]++;
          return _context2.abrupt("return", null);
        case 32:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 28]]);
  }));
  return _logError.apply(this, arguments);
}
function logWidgetInfo(_x7, _x8, _x9) {
  return _logWidgetInfo.apply(this, arguments);
}
function _logWidgetInfo() {
  _logWidgetInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(widgetName, widgetBaseURL, headers) {
    var logHostName, usagePlaceURL, debugClientId, version, logPayload;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          cov_1os3lnb8am().f[14]++;
          cov_1os3lnb8am().s[62]++;
          _context3.prev = 2;
          logHostName = (cov_1os3lnb8am().s[63]++, getHostNameFromURL(widgetBaseURL));
          cov_1os3lnb8am().s[64]++;
          if (logHostName) {
            _context3.next = 11;
            break;
          }
          cov_1os3lnb8am().b[22][0]++;
          cov_1os3lnb8am().s[65]++;
          return _context3.abrupt("return", null);
        case 11:
          cov_1os3lnb8am().b[22][1]++;
        case 12:
          usagePlaceURL = (cov_1os3lnb8am().s[66]++, getWindowLocation());
          cov_1os3lnb8am().s[67]++;
          _context3.next = 16;
          return getDebugClientId(headers);
        case 16:
          debugClientId = _context3.sent;
          version = (cov_1os3lnb8am().s[68]++, (cov_1os3lnb8am().b[23][0]++, process.env.BUILD_VERSION) || (cov_1os3lnb8am().b[23][1]++, 'UNKNOWN'));
          logPayload = (cov_1os3lnb8am().s[69]++, {
            widgetInfo: widgetName,
            usagePlaceURL: usagePlaceURL,
            debugClientId: debugClientId,
            version: version
          });
          cov_1os3lnb8am().s[70]++;
          return _context3.abrupt("return", _axios.default.post(LogEndPoint.WIDGET_INFO, logPayload, {
            headers: {
              'X-Stx-Authn': TEMP_LOG_STX_AUTHN
            },
            baseURL: getLogApiBaseURL(logHostName)
          }));
        case 23:
          _context3.prev = 23;
          _context3.t0 = _context3["catch"](2);
          cov_1os3lnb8am().s[71]++;
          return _context3.abrupt("return", null);
        case 27:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[2, 23]]);
  }));
  return _logWidgetInfo.apply(this, arguments);
}
function logWidgetUsageInfo(_x10, _x11, _x12) {
  return _logWidgetUsageInfo.apply(this, arguments);
}
function _logWidgetUsageInfo() {
  _logWidgetUsageInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(widgetUsageInfo, widgetBaseURL, headers) {
    var logHostName, usagePlaceURL, debugClientId, version, logPayload;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          cov_1os3lnb8am().f[15]++;
          cov_1os3lnb8am().s[72]++;
          _context4.prev = 2;
          logHostName = (cov_1os3lnb8am().s[73]++, getHostNameFromURL(widgetBaseURL));
          cov_1os3lnb8am().s[74]++;
          if (logHostName) {
            _context4.next = 11;
            break;
          }
          cov_1os3lnb8am().b[24][0]++;
          cov_1os3lnb8am().s[75]++;
          return _context4.abrupt("return", null);
        case 11:
          cov_1os3lnb8am().b[24][1]++;
        case 12:
          usagePlaceURL = (cov_1os3lnb8am().s[76]++, getWindowLocation());
          cov_1os3lnb8am().s[77]++;
          _context4.next = 16;
          return getDebugClientId(headers);
        case 16:
          debugClientId = _context4.sent;
          version = (cov_1os3lnb8am().s[78]++, (cov_1os3lnb8am().b[25][0]++, process.env.BUILD_VERSION) || (cov_1os3lnb8am().b[25][1]++, 'UNKNOWN'));
          logPayload = (cov_1os3lnb8am().s[79]++, {
            widgetInfo: widgetUsageInfo,
            usagePlaceURL: usagePlaceURL,
            debugClientId: debugClientId,
            version: version
          });
          cov_1os3lnb8am().s[80]++;
          return _context4.abrupt("return", _axios.default.post(LogEndPoint.WIDGET_INFO, logPayload, {
            headers: {
              'X-Stx-Authn': TEMP_LOG_STX_AUTHN
            },
            baseURL: getLogApiBaseURL(logHostName)
          }));
        case 23:
          _context4.prev = 23;
          _context4.t0 = _context4["catch"](2);
          cov_1os3lnb8am().s[81]++;
          return _context4.abrupt("return", null);
        case 27:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 23]]);
  }));
  return _logWidgetUsageInfo.apply(this, arguments);
}
var _default = exports.default = _axios.default;